import * as yup from 'yup';

// TODO: Move this to Configuration.ts at some point
interface FieldConfig {
  type: string;
  defaultValue: string | number | boolean;
  label: string;
  uniqueFrom: string[];
  min: number;
  max: number;
  disabled: boolean;
  required: boolean;
}

interface Model {
  [fieldName: string]: Partial<FieldConfig>;
}

export const getValidationForModel = (model: Model) => {
  let shape: Record<string, yup.AnySchema> = {};

  for (const [fieldName, fieldConfig] of Object.entries(model)) {
    let validator: yup.AnySchema;

    switch (fieldConfig.type) {
      case 'string':
        validator = yup.string();
        break;
      case 'number':
        validator = yup.number();
        break;
      case 'boolean':
        validator = yup.boolean();
        break;
      case 'mixed':
      default:
        validator = yup.mixed();
        break;
    }

    if (fieldConfig.required) {
      validator = validator.required('Required!');
    }

    // Apply min/max constraints if defined and field is numeric
    if (typeof fieldConfig.min !== 'undefined' && fieldConfig.type === 'number') {
      validator = (validator as yup.NumberSchema).min(fieldConfig.min, `Min: ${fieldConfig.min}`);
    }

    if (typeof fieldConfig.max !== 'undefined' && fieldConfig.type === 'number') {
      validator = (validator as yup.NumberSchema).max(fieldConfig.max, `Max: ${fieldConfig.max}`);
    }

    // If the field requires a unique value from others, add a test
    if (fieldConfig.uniqueFrom) {
      validator = validator.test(
        `${fieldName}-uniqueFrom`,
        `Value for ${fieldName} must be unique from fields: ${fieldConfig.uniqueFrom.join(', ')}`,
        function (value) {
          const {parent} = this;
          if (!value) return true;

          if (typeof fieldConfig.uniqueFrom === 'undefined') {
            return true;
          }

          for (const otherField of fieldConfig.uniqueFrom) {
            const otherValue = parent[otherField];
            if (otherValue?.toString() === value?.toString()) {
              return this.createError({
                path: this.path,
                message: `The value for "${fieldConfig.label}" cannot be the same as "${model[otherField].label}".`,
              });
            }
          }
          return true;
        },
      );
    }

    shape[fieldName] = validator;
  }
  return yup.object().shape(shape);
};
